import React, { useState, useEffect } from 'react';
import {
  Spin, Button, Card, Tooltip, Input, Modal, Space, Table, message
} from 'antd';
import {
  EditOutlined, ReloadOutlined
} from '@ant-design/icons';
import 'antd/dist/antd.css';
import Fuse from 'fuse.js';
import _ from 'lodash';
import moment from 'moment';
import * as Service from '../core/Service';
import NavAndSideFrame from '../components/NavAndSideFrame';
import NewsForm from '../components/NewsForm';
import { useTranslation } from 'react-i18next';

const title = `交通消息列表`;
const selectedKey = `trafficnews_list`;
const tableIdName = `trafficnews_id`;
const filterableField = [
  'trafficnews_content', 'trafficnews_title'
];
const defaultFormData = {
  trafficnews_title: '交通消息',
  trafficnews_content: undefined
}

const TrafficNewsList = (props) => {
  const {t} = useTranslation();

  const [dataList, setDataList] = useState([]);
  const [unChangeData, setUnChangeData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  // const [isShowPassword, setShowPassword] = useState(false);
  // const [isChangingIsActive, setChangingIsActive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    let endpoint = `/api/trafficnews/list`;
    let list = [];
    setLoading(true);
    try {
      let data = await Service.call(`GET`, endpoint);
      list = _.orderBy(data, [`ctime`], [`desc`]);
      if (data.errorMessage) list = [];
    } catch (error) {
      console.log(error);
    } finally {
      setDataList(list);
      setUnChangeData(list);
      setLoading(false);
    }
  }

  const resendTrafficNews = async (record) => {
    const method = `PUT`;
    const endpoint = `/api/trafficnews`;

    const bodyObj = {
      [tableIdName]: record.trafficnews_id,
    };

    try {
      let resp = await Service.call(method, endpoint, bodyObj);
      if (resp.errorMessage) {
        message.error(resp.errorMessage);
        return;
      }
      message.success(t('common.success'));

      getAllData();
      return;
    } catch (error) {
      console.log(error);
    }
  }

  const setTableHeader = () => {
    let columns = [
      {
        title: '操作',
        dataIndex: tableIdName,
        render: (value, record) => {
          return (
            <span>
              <Tooltip title={t('common.edit')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 8, color: '#000000' }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setSelectedRecord(record);
                    setModalVisible(true);
                  }}
                />
              </Tooltip>
              <Tooltip title={t('ad.resend')}>
                <Button
                  shape="circle"
                  style={{ marginRight: 8, color: '#000000' }}
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    resendTrafficNews(record);
                  }}
                />
              </Tooltip>
              {/* <Tooltip title={record.is_active ? 'Disable Admin' : 'Enable Admin'}>
                <Button
                  shape="circle"
                  style={{ color: record.is_active ? 'red' : 'green' }}
                  icon={record.is_active ? (<StopOutlined />) : (<CheckOutlined />)}
                  onClick={async () => {
                    if (isChangingIsActive) return; // avoid multiple attempts

                    setChangingIsActive(true);
                    let { admin_id, is_active } = record;
                    is_active = !is_active;

                    let result = await Service.call('put', `/api/admin`, { admin_id, is_active });
                    setChangingIsActive(false);

                    if (_.isEmpty(result) || result.status < 1) {
                      return message.error(is_active ? 'Fail to enable admin' : 'Fail to disable admin');
                    }
                    await getAllData();
                    return message.success(is_active ? 'Admin enabled' : 'Admin disabled');
                  }}
                />
              </Tooltip> */}
            </span>
          )
        }
      },
      { title: '交通消息編號', dataIndex: tableIdName },
      // {
      //   title: 'is_active',
      //   dataIndex: 'is_active',
      //   render: (value) => {
      //     return displayIsActive(value);
      //   },
      //   ellipsis: true
      // },
      { title: `標題`, dataIndex: `trafficnews_title` },
      { title: `內容`, dataIndex: `trafficnews_content` },
      // {
      //   title: '創建時間',
      //   dataIndex: 'ctime',
      //   render: (value) => {
      //     return displayMoment(value);
      //   },
      //   ellipsis: true,
      // },
      {
        title: '更新時間',
        dataIndex: 'utime',
        render: (value) => {
          return displayMoment(value);
        },
        sorter: (a, b) => a.utime - b.utime,
        defaultSortOrder: 'descend',
      },

    ];
    return columns;
  }

  const displayMoment = (unixTime, outputFormat = 'YYYY/MM/DD HH:mm') => {
    if (unixTime !== 0) {
      let displayTime = moment.unix(unixTime).format(outputFormat);
      return displayTime;
    }
    return '-';
  }

  const getDataBySearchKeyword = (keywords) => {
    let dataList = [];
    try {
      const options = {
        includeScore: true,
        findAllMatches: true,
        threshold: 0.15,
        keys: filterableField
      }
      const fuse = new Fuse(unChangeData, options)
      const result = fuse.search(keywords);
      console.log("RESULT", result);
      dataList = _.map(result, 'item');
      dataList = _.orderBy(dataList, [`ctime`], [`desc`]);
    } catch (error) {
      console.error('error >>> ', error);
    } finally {
      setDataList(dataList);
    }
  }

  let timeout;
  const debounce = (func, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(func, delay);
  };

  const onChange = (keyword) => {
    debounce(() => {
      getDataBySearchKeyword(keyword);
      if (_.isEmpty(keyword)) setDataList(unChangeData);
    }, 400);
  };

  return (
    <NavAndSideFrame {...props} title={title} selectedKey={selectedKey}>
      <Card>
        <Button
          icon={<EditOutlined />}
          style={{ marginRight: 10 }}
          type="primary"
          onClick={() => {
            setSelectedRecord(defaultFormData);
            setModalVisible(true);
          }}
        >
          新增
        </Button>

        <Space direction="horizontal">
          <>以文字搜尋:</>
          <Input
            placeholder="請輸入文字"
            onChange={(values) => {
              onChange(values.target.value);
            }}
          />
        </Space>
      </Card>

      <Card>
        <Spin spinning={loading}>
          <Table
            pagination={{
              defaultPageSize: 25,
              showSizeChanger: true,
              pageSizeOptions: [25, 50, 100, 200, 500]
            }}

            scroll={{ x: `max-content` }}
            dataSource={dataList}
            columns={setTableHeader()}
            rowKey={tableIdName}
          />
        </Spin>
      </Card>
      <Modal
        title={t('title.traffic_news')}
        visible={modalVisible}
        footer={null}
        style={{ maxWidth: 800 }}
        width="90%"
        onCancel={() => { setModalVisible(false) }}
        destroyOnClose
      >
        <NewsForm
          selectedRecord={selectedRecord}
          openModal={(value) => {
            getAllData();
            setModalVisible(value);
          }}
        />
      </Modal>
    </NavAndSideFrame>
  );
}

export default TrafficNewsList;